module.exports = __webpack_public_path__ + "img/b_log_silence.6b27ec63.png";